/**
 * Tracking numbers that have at least one voided row.
 *
 * Voiding a UPS shipment leaves TWO rows carrying the same tracking number:
 * the void record, and the original booking, which still reads void === "N".
 * Striking through only the flagged row left its twin looking live -- and the
 * live-looking one is exactly the row somebody would act on.
 *
 * So the strike follows the TRACKING NUMBER rather than a row's own flag.
 * The pair is usually adjacent and usually ordered void-record-first, but
 * neither is guaranteed, so matching is by value and order-independent.
 *
 * Lives in its own module, with no imports, so it can be tested without
 * pulling in UpsTracking.jsx -- that drags in services/axios, which is ESM and
 * is not transformed by CRA's Jest.
 */
export const collectVoidedTrackingNumbers = (rows) => {
  const voided = new Set();
  for (const row of rows || []) {
    // A blank tracking number must never enter the set, or every other row
    // missing one would match it.
    if (row?.void === "Y" && row?.trackingNumber) {
      voided.add(row.trackingNumber);
    }
  }
  return voided;
};

export default collectVoidedTrackingNumbers;
